import { render, staticRenderFns } from "./DocCabinet.vue?vue&type=template&id=6d7f080a"
import script from "./DocCabinet.vue?vue&type=script&lang=js"
export * from "./DocCabinet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports